import { works } from "../assets/content/works";
import { Container } from "../components/Container";
import { Works } from "../components/sections/Works";
import { useLanguage } from "../providers/language_provider";

export const Catalogue = () => {
    return (
        <Container>
            <div className="min-h-screen pb-12 pt-32 flex flex-col justify-center bg-gradient-to-b from-40% from-black to-gray-500">
                <Works works={works} isAll={false}/>
            </div>
        </Container>
    );
};